var _title, _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500",
  width: 100,
  height: 80,
  y: "-20px",
  x: "20px"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "JOS")), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0 { fill: #3b623b } \n\t\t.s1 { fill: #fcfcfc } \n\t\t.s2 { fill: #fcfdfc } \n\t\t.s3 { fill: #fdfefd }")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m-0.5-0.5q250 0 500 0 0 250 0 500-250 0-500 0 0-250 0-500z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s1",
  d: "m215.5 172.5q64.8 0.5 74.5 65 4.1 40.8-22 72-29.4 25-66.5 13.5-39.1-20.9-42.5-65.5-4.3-44.6 29.5-73.5 12.6-8.3 27-11.5z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s2",
  d: "m371.5 172.5q40.7-3.4 64 29.5-9.9 8.8-20.5 16.5-9-13-23.5-19.5-14.9-3.8-29 2-15.4 10.4-4 25 4 2 8 4 15.5 3.5 31 7 52.9 13 34.5 64.5-13.1 19.6-36.5 23.5-34.6 7.3-63-13-8.2-6.7-13-16 9.3-9.6 21-16.5 20.2 27.6 54 20.5 19.2-7.2 12.5-26.5-5.2-5.5-12.5-7.5-25.7-4.7-50-14-22.6-16-17.5-43.5 6.3-22.3 27.5-31.5 8.4-3.4 17-4.5z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s3",
  d: "m96.5 176.5q12.5 0 25 0 0.7 62-1.5 124-7.9 20.3-29.5 24.5-14.1 1.1-28-0.5 0-13.5 0-27 13.3 2.6 26-1.5 5.1-3.5 6.5-9.5 2.2-54.9 1.5-110z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  fillRule: "evenodd",
  className: "s0",
  d: "m219.5 197.5q28.1-0.6 39.5 25 11.1 29.2-1 58-20.2 31.2-53.5 14.5-15.3-13.4-18.5-33.5-3.3-22.9 6-44 9.5-16.1 27.5-20z"
}))));
export { SvgLogo as ReactComponent };